export { default } from './MedicationDetailsPopup';
